import { Icon } from '../Icon';

export default function Spinner() {
  return (
    <div className="d-flex justify-center">
      <Icon type="material" className="text-primary spinner">
        data_usage
      </Icon>
    </div>
  );
}
